import { render } from "./Tournament.vue?vue&type=template&id=63eab195&scoped=true"
import script from "./Tournament.vue?vue&type=script&lang=js"
export * from "./Tournament.vue?vue&type=script&lang=js"

import "./Tournament.vue?vue&type=style&index=0&id=63eab195&lang=css"
import "./Tournament.vue?vue&type=style&index=1&id=63eab195&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63eab195"]])

export default __exports__